export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="31"
      viewBox="0 0 40 31"
    >
      <path
        fill="#FFF"
        fill-rule="evenodd"
        d="M0,7.50000061 C0,7.80938691 0.09374908,8.06352096 0.28125,8.26241549 C0.4687508,8.46130577 0.708332,8.56074879 1,8.56074879 L20.5625,8.56074879 L16.3125,13.1352253 C15.812496,13.621404 15.80208,14.1186246 16.281248,14.6269024 C16.76042,15.1351803 17.229164,15.1241307 17.6875,14.5937541 L23.6875,8.22926499 C23.8125,8.14087072 23.895832,8.0303747 23.9375,7.89778118 C23.979168,7.76518766 24,7.63259414 24,7.50000061 C24,7.36740709 23.979168,7.23481357 23.9375,7.10222005 C23.895832,6.96962653 23.8125,6.85913051 23.6875,6.77073624 L17.6875,0.406247176 C17.229164,-0.124131156 16.76042,-0.135179909 16.281248,0.373096674 C15.80208,0.881377499 15.812496,1.37859684 16.3125,1.86477592 L20.5625,6.43925244 L1,6.43925244 C0.708332,6.43925244 0.4687508,6.53869546 0.28125,6.73758574 C0.09374908,6.93648027 0,7.19061432 0,7.50000061 Z"
        transform="translate(8 8)"
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/assets/images/right-arrow.js